import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { GetCorporateHrlist } from "./HrAction";

export const actionTypes = {
  NEW_BRANCH: "NEW_BRANCH",
  LOADER: "LOADER",
  BRANCH_LIST : "BRANCH_LIST",
  ALL_BRANCH_LIST : "ALL_BRANCH_LIST",
  ALL_MEMBER_LIST : "ALL_MEMBER_LIST",
  ADMIN_LIST : "ADMIN_LIST",
  ALL_MASTER_MEMBER_LIST : "ALL_MASTER_MEMBER_LIST",
  ALL_MASTER_DATA : "ALL_MASTER_DATA",
  ALL_BRANCH_LIST_ADMIN : "ALL_BRANCH_LIST_ADMIN",
  ALL_FAMILY_MEMBER_LIST : "ALL_FAMILY_MEMBER_LIST",
  ALL_FAMILY_CORPORATE_LIST : 'ALL_FAMILY_CORPORATE_LIST',
  ALL_VFS_UK_DATA : 'ALL_VFS_UK_DATA'
};

export const MasterAdminLoader = () => {
  return {
    type: actionTypes.LOADER,
    corporateloader: true,
  };
};

//  create new branch
export const CreateBranch = (Data, query , setCorporatemodel) => {
    const authToken = localStorage.getItem("Admin");
    const token = JSON.parse(authToken)?.data?.token;
    return async (dispatch) => {
      await axios
        .post(`${process.env.REACT_APP_API_BASE_URL}/create-branch`, Data, {
          headers: {
            "x-access-token": token,
          },
        })
        .then((response) => {
          dispatch({
            type: actionTypes.NEW_BRANCH,
            NewBranch: response.data,
            corporateloader: false,
          });
          setCorporatemodel(false);
          dispatch(GetBranchlist());
          toast.success(response?.data?.message, {
            theme: "colored",
            autoClose: 2000,
          });
        })
        .catch((err) => {
          if (err) {
            dispatch({
              type: actionTypes.LOADER,
              corporateloader: false,
            });
          setCorporatemodel(false);
            toast.error(err?.response?.data?.error, {
              theme: "colored",
              autoClose: 2000,
            });
          }
        });
    };
  };

  // get branch list

  export const GetBranchlist = (query) => {
    const authToken = localStorage.getItem("Admin");
    const token = JSON.parse(authToken)?.data?.token;
    const master_CorpoId = JSON.parse(authToken)?.data?.corporateID || process.env.REACT_APP_CORPORATE_ID;
  
    return async (dispatch) => {
      await axios
        .get(`${process.env.REACT_APP_API_BASE_URL}/get-branch/${master_CorpoId}`, {
          params: { ...query },
          headers: {
            "x-access-token": token,
          },
        })
        .then((response) => {
          dispatch({
            type: actionTypes.BRANCH_LIST,
            BranchList: response.data,
          });
        })
        .catch((err) => {
          // console.log(err);
        });
    };
  };

// get all branch list
  export const GetAllBranchlist = (query) => {
    const authToken = localStorage.getItem("Admin");
    const token = JSON.parse(authToken)?.data?.token;
    const master_CorpoId = JSON.parse(authToken)?.data?.corporateID || process.env.REACT_APP_CORPORATE_ID;
  
    return async (dispatch) => {
      await axios
        .get(`${process.env.REACT_APP_API_BASE_URL}/branch-list/${master_CorpoId}`, {
          params: { ...query },
          headers: {
            "x-access-token": token,
          },
        })
        .then((response) => {
          dispatch({
            type: actionTypes.ALL_BRANCH_LIST,
            AllBranchList: response.data,
          });
        })
        .catch((err) => {
          // console.log(err);
        });
    };
  };

  // create single member

  export const CreateMember = (Data, qurey) => {
    const authToken = localStorage.getItem("Admin");
    const token = JSON.parse(authToken)?.data?.token;
    return async (dispatch) => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/master-create-employee`,
          Data,
          {
            headers: {
              "x-access-token": token,
            },
          }
        );
        toast.success(response?.data?.message, {
          theme: "colored",
          autoClose: 2000,
        });
        dispatch({
          type: actionTypes.LOADER,
          corporateloader: false,
        });
        return response;
      } catch (err) {
        console.log(err,'err');
        toast.error(err?.response?.data?.error, {
          theme: "colored",
          autoClose: 2000,
        });
        dispatch({
          type: actionTypes.LOADER,
          corporateloader: false,
        });
        throw err;
      }
    };
  };

  // get all member list

  export const GetMemberlist = (query) => {
    const authToken = localStorage.getItem("Admin");
    const token = JSON.parse(authToken)?.data?.token;
    const master_CorpoId = JSON.parse(authToken)?.data?.corporateID || process.env.REACT_APP_CORPORATE_ID;
  
    return async (dispatch) => {
      await axios
        .get(`${process.env.REACT_APP_API_BASE_URL}/master-employee/${master_CorpoId}`, {
          params: { ...query },
          headers: {
            "X-access-token": token,
          },
        })
        .then((response) => {
          dispatch({
            type: actionTypes.ALL_MEMBER_LIST,
            MemberList: response.data,
          });
        })
        .catch((err) => {
          // console.log(err)
        });
    };
  };

  // export brach data
  export const ExportBranchData = (query) => {

    const authToken = localStorage.getItem("Admin");
    const token = JSON.parse(authToken)?.data?.token;
    const master_CorpoId = JSON.parse(authToken)?.data?.corporateID || process.env.REACT_APP_CORPORATE_ID;
  
    return async (dispatch) => {
      await axios
        .get(`${process.env.REACT_APP_API_BASE_URL}/master-employee-export/${master_CorpoId}`,
        {
          params: { ...query },
          headers: {
            "X-access-token": token,
          },
          responseType: 'blob'
        })
        .then((response) => {
          const blob = response.data;
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = `Export_Data.xlsx`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          toast.success("Data exported successfully.", {
            theme: "colored",
            autoClose: 2000,
          });
          dispatch({
            type: actionTypes.LOADER,
            corporateloader: false,
          });
        })
        .catch((err) => {
          toast.error(err?.response?.data?.error || "Record not found", {
            theme: "colored",
            autoClose: 2000,
          });
          dispatch({
            type: actionTypes.LOADER,
            corporateloader: false,
          });
        });
    };
  };

  // upload member

  export const uploadMember = (formData , setSelectFile , setSelectedCorporate) => async (dispatch) => {
    const authToken = localStorage.getItem("Admin");
    const token = JSON.parse(authToken)?.data?.token;
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/master-emp-create-file`,
        formData,
        {
          headers: {
            "x-access-token": token,
          },
        }
      );
      toast.success(response.data.message, {
        autoClose: 2000,
        theme: "colored",
      });
      dispatch({
        type: actionTypes.LOADER,
        corporateloader: false,
      });
      setSelectFile(null)
      setSelectedCorporate("")
    } catch (error) {
      setSelectFile(null)
      toast.error(error.response.data.error, {
        autoClose: 2000,
        theme: "colored",
      });
      dispatch({
        type: actionTypes.LOADER,
        corporateloader: false,
      });
    }
  };


  // get Admins list

  export const GetAdminslist = (query) => {
    const authToken = localStorage.getItem("Admin");
    const token = JSON.parse(authToken)?.data?.token;
    const master_CorpoId = JSON.parse(authToken)?.data?.corporateID || process.env.REACT_APP_CORPORATE_ID;
    return async (dispatch) => {
      await axios
        .get(
          `${process.env.REACT_APP_API_BASE_URL}/master-hr-list/${master_CorpoId}`,
          {
            params: { ...query },
            headers: {
              "x-access-token": token,
            },
          }
        )
        .then((response) => {
          dispatch({
            type: actionTypes.ADMIN_LIST,
            AdminList: response.data,
            corporateloader: false,
          });
        })
        .catch((err) => {
          //  console.log(err)
        });
    };
  };


  export const GetMasterCorpolist = (query) => {
    const authToken = localStorage.getItem("Admin");
    const token = JSON.parse(authToken)?.data?.token;
  
    return async (dispatch) => {
      await axios
        .get(`${process.env.REACT_APP_API_BASE_URL}/master-corpo-list`, {
          params: { ...query },
          headers: {
            "X-access-token": token,
          },
        })
        .then((response) => {
          dispatch({
            type: actionTypes.ALL_MASTER_MEMBER_LIST,
            AllMasterMemberList: response.data,
          });
        })
        .catch((err) => {
          // console.log(err)
        });
    };
  };


  export const GetMasterMemberlist = (query) => {
    const authToken = localStorage.getItem("Admin");
    const token = JSON.parse(authToken)?.data?.token;
  
    return async (dispatch) => {
      await axios
        .get(`${process.env.REACT_APP_API_BASE_URL}/master-member-list`, {
          params: { ...query },
          headers: {
            "X-access-token": token,
          },
        })
        .then((response) => {
          dispatch({
            type: actionTypes.ALL_MASTER_DATA,
            AllMasterData: response.data,
          });
        })
        .catch((err) => {
          // console.log(err)
        });
    };
  };

  export const GetVfsUklist = (query) => {
    const authToken = localStorage.getItem("Admin");
    const token = JSON.parse(authToken)?.data?.token;
  
    return async (dispatch) => {
      await axios
        .get(`${process.env.REACT_APP_API_BASE_URL}/uk/master-member-list`, {
          params: { ...query },
          headers: {
            "X-access-token": token,
          },
        })
        .then((response) => {
          dispatch({
            type: actionTypes.ALL_VFS_UK_DATA,
            AllVfsUkData: response.data,
          });
        })
        .catch((err) => {
          // console.log(err)
        });
    };
  };

  export const GetAllBranchlistAdmin = (master_CorpoId) => {
    const authToken = localStorage.getItem("Admin");
    const token = JSON.parse(authToken)?.data?.token;
  
    return async (dispatch) => {
      await axios
        .get(`${process.env.REACT_APP_API_BASE_URL}/admin/branch-list/${master_CorpoId}`, {
          headers: {
            "x-access-token": token,
          },
        })
        .then((response) => {
          dispatch({
            type: actionTypes.ALL_BRANCH_LIST_ADMIN,
            AllBranchListAdmin : response.data,
          });
        })
        .catch((err) => {
          // console.log(err);
        });
    };
  };

  // export data

  export const ExportMasterBranchData = (query) => {

    const authToken = localStorage.getItem("Admin");
    const token = JSON.parse(authToken)?.data?.token;
  
    return async (dispatch) => {
      await axios
        .get(`${process.env.REACT_APP_API_BASE_URL}/admin/master-member-list-export`,
        {
          params: { ...query },
          headers: {
            "X-access-token": token,
          },
          responseType: 'blob'
        })
        .then((response) => {
          const blob = response.data;
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = `Export_Data.xlsx`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          toast.success("Data exported successfully.", {
            theme: "colored",
            autoClose: 2000,
          });
          dispatch({
            type: actionTypes.LOADER,
            corporateloader: false,
          });
        })
        .catch((err) => {
          toast.error(err?.response?.data?.error, {
            theme: "colored",
            autoClose: 2000,
          });
          dispatch({
            type: actionTypes.LOADER,
            corporateloader: false,
          });
        });
    };
  };


  // send admin mail

  export const AdminSendMail = (empID) => {
    const authToken = localStorage.getItem("Admin");
    const token = JSON.parse(authToken)?.data?.token;
  
  
    return async (dispatch) => {
      await axios
        .patch(
          `${process.env.REACT_APP_API_BASE_URL}/master/admin-send-mail/${empID}`,
          {},
          {
            headers: {
              "x-access-token": token,
            },
          }
        )
        .then((response) => {
          dispatch({
            type: actionTypes.LOADER,
            corporateloader: false,
          });
          toast.success(response?.data?.message, {
            theme: "colored",
            autoClose: 2000,
          });
        })
        .catch((err) => {
          if (err) {
            dispatch({
              type: actionTypes.LOADER,
              corporateloader: false,
            });
          }
          toast.error(err?.response?.data?.error, {
            theme: "colored",
            autoClose: 2000,
          });
        });
    };
  };
  

  // edit admin

  export const EditAdminDetail = (empID , data , query , setEditCorpModel) => {
    const authToken = localStorage.getItem("Admin");
    const token = JSON.parse(authToken)?.data?.token;
    const role = JSON.parse(authToken)?.data;
  
    return async (dispatch) => {
      await axios
        .patch(
          `${process.env.REACT_APP_API_BASE_URL}/master/admin-update/${empID}`,
          data,
          {
            headers: {
              "x-access-token": token,
            },
          }
        )
        .then((response) => {
          dispatch({
            type: actionTypes.LOADER,
            corporateloader: false,
          });
          if(role?.role === "Corporate" || role?.role === "Corporate-branch"){
            dispatch(GetCorporateHrlist(role?.corporateID , query))
          }else if(role?.role === "Master-Corporate"){
            dispatch(GetAdminslist(query));
          }
          setEditCorpModel(false);
          toast.success(response?.data?.message, {
            theme: "colored",
            autoClose: 2000,
          });
        })
        .catch((err) => {
          if (err) {
            dispatch({
              type: actionTypes.LOADER,
              corporateloader: false,
            });
          }
          toast.error(err?.response?.data?.error, {
            theme: "colored",
            autoClose: 2000,
          });
        });
    };
  };

  // update admin status

  export const UpdateAdminStatus = (_id, status, query) => {
    const authToken = localStorage.getItem("Admin");
    const token = JSON.parse(authToken)?.data?.token;
    const data = {
      status: status,
    };
  
    return async (dispatch) => {
      await axios
        .patch(
          `${process.env.REACT_APP_API_BASE_URL}/master/admin-status/${_id}`,
          data,
          {
            headers: {
              "x-access-token": token,
            },
          }
        )
        .then((response) => {
          dispatch(GetAdminslist(query));
          toast.success(response?.data?.message, {
            theme: "colored",
            autoClose: 2000,
          });
        })
        .catch((err) =>
          toast.error(err?.response?.data?.error, {
            theme: "colored",
            autoClose: 2000,
          })
        );
    };
  };
  

  // send Member mail

  export const MemberSendMail = (empID) => {
      const authToken = localStorage.getItem("Admin");
      const token = JSON.parse(authToken)?.data?.token;
    
    
      return async (dispatch) => {
        await axios
          .patch(
            `${process.env.REACT_APP_API_BASE_URL}/master/member-send-mail/${empID}`,
            {},
            {
              headers: {
                "x-access-token": token,
              },
            }
          )
          .then((response) => {
            dispatch({
              type: actionTypes.LOADER,
              corporateloader: false,
            });
            toast.success(response?.data?.message, {
              theme: "colored",
              autoClose: 2000,
            });
          })
          .catch((err) => {
            if (err) {
              dispatch({
                type: actionTypes.LOADER,
                corporateloader: false,
              });
            }
            toast.error(err?.response?.data?.error, {
              theme: "colored",
              autoClose: 2000,
            });
          });
      };
  };


  export const GetAdminFamilyMemberlist = (query) => {
    const authToken = localStorage.getItem("Admin");
    const token = JSON.parse(authToken)?.data?.token;
  
    return async (dispatch) => {
      await axios
        .get(`${process.env.REACT_APP_API_BASE_URL}/admin/get-all/family/members`, {
          params: { ...query },
          headers: {
            "X-access-token": token,
          },
        })
        .then((response) => {
          dispatch({
            type: actionTypes.ALL_FAMILY_MEMBER_LIST ,
            AllFamilyMemberList: response.data,
          });
        })
        .catch((err) => {
          // console.log(err)
        });
    };
  };

  export const GetAllFamilyCorporateList = (master_CorpoId) => {
    const authToken = localStorage.getItem("Admin");
    const token = JSON.parse(authToken)?.data?.token;
  
    return async (dispatch) => {
      await axios
        .get(`${process.env.REACT_APP_API_BASE_URL}/admin/family/corporate`, {
          headers: {
            "x-access-token": token,
          },
        })
        .then((response) => {
          dispatch({
            type: actionTypes.ALL_FAMILY_CORPORATE_LIST,
            AllFamilyCorporateList : response.data,
          });
        })
        .catch((err) => {
          // console.log(err);
        });
    };
  };

  // export family member data

  export const ExportFamilyMemberData = (query) => {

    const authToken = localStorage.getItem("Admin");
    const token = JSON.parse(authToken)?.data?.token;
  
    return async (dispatch) => {
      await axios
        .get(`${process.env.REACT_APP_API_BASE_URL}/admin/get-all/family/members/excel`,
        {
          params: { ...query },
          headers: {
            "X-access-token": token,
          },
          responseType: 'blob'
        })
        .then((response) => {
          const blob = response.data;
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = `Export_Data.xlsx`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          toast.success("Data exported successfully.", {
            theme: "colored",
            autoClose: 2000,
          });
          dispatch({
            type: actionTypes.LOADER,
            corporateloader: false,
          });
        })
        .catch((err) => {
          toast.error(err?.response?.data?.error, {
            theme: "colored",
            autoClose: 2000,
          });
          dispatch({
            type: actionTypes.LOADER,
            corporateloader: false,
          });
        });
    };
  };

  // export vfs uk data

    export const ExportVfsUkData = (query) => {

    const authToken = localStorage.getItem("Admin");
    const token = JSON.parse(authToken)?.data?.token;
  
    return async (dispatch) => {
      await axios
        .get(`${process.env.REACT_APP_API_BASE_URL}/uk/master-memer-list/export`,
        {
          params: { ...query },
          headers: {
            "X-access-token": token,
          },
          responseType: 'blob'
        })
        .then((response) => {
          const blob = response.data;
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = `Export_Data.xlsx`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          toast.success("Data exported successfully.", {
            theme: "colored",
            autoClose: 2000,
          });
          dispatch({
            type: actionTypes.LOADER,
            corporateloader: false,
          });
        })
        .catch((err) => {
          toast.error(err?.response?.data?.error, {
            theme: "colored",
            autoClose: 2000,
          });
          dispatch({
            type: actionTypes.LOADER,
            corporateloader: false,
          });
        });
    };
  };